// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-5ab2bd67] .el-input-group__append {\n  background-color: #fff;\n  border-radius: 0px;\n}\n", ""]);
// Exports
module.exports = exports;
